import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getRoleCreate: 'getRoleCreate',
      getRoleEdit: 'getRoleEdit',
      getRoleApprove: 'getRoleApprove',
      getRoleDelete: 'getRoleDelete',
      getAppCurrent: 'getAppCurrent',
      getMetadata: 'getMetadata',
    }),
    appId() {
      return this.getAppCurrent.app_id
    },
    moduleId() {
      return this.getAppCurrent.module_id
    },
    submoduleId() {
      return this.getAppCurrent.submodule_id
    },
    hasRoleCreate() {
      return this.getRoleCreate(this.appId, this.moduleId, this.submoduleId)
    },
    hasRoleEdit() {
      return this.getRoleEdit(this.appId, this.moduleId, this.submoduleId)
    },
    hasRoleApprove() {
      return this.getRoleApprove(this.appId, this.moduleId, this.submoduleId)
    },
    hasRoleDelete() {
      return this.getRoleDelete(this.appId, this.moduleId, this.submoduleId)
    },
    showOptionButton() {
      return this.hasRoleDelete
    },
    getRoleMetadata() {
      return this.getMetadata(this.appId, this.moduleId, this.submoduleId)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/userPermission.js